<template>
  <div class="text-xs text_color cursor-pointer w-full">
    <span class="text-sm text_color">
      {{ props.value || "-" }}
    </span>
  </div>
</template>
<script setup>
import { defineProps } from "vue";

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  row: {
    type: Object,
    default: () => ({}),
  },
});
</script>
